import IAceitarTermosOnboardingRequest from '../entities/IAceitarTermosOnboardingRequest'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface IAceitarTermosOnboarding {
  execute(data: IAceitarTermosOnboardingRequest): Promise<void>
}

export default class AceitarTermosOnboardingImpl
  implements IAceitarTermosOnboarding
{
  constructor(private readonly pagamentosRepository: IPagamentoRepository) {}
  async execute(data: IAceitarTermosOnboardingRequest): Promise<void> {
    return this.pagamentosRepository.aceitarTermosDeUsoOnboarding(data)
  }
}
